import { AppTask } from 'aurelia';
import { IContainer } from '@aurelia/kernel';
import { IGoogleAnalytics } from './common/google-analytics';
import { ITokenService } from './services/token-service';

export const ConfigureStartup = {
    register(container: IContainer): IContainer {
        return container.register(
            AppTask.activated(() => {
                const ga = container.get(IGoogleAnalytics);
                ga.init('UA-44935027-4');
                ga.attach();

                const tokenService = container.get(ITokenService);

                // refresh token every 20 minutes
                setInterval(async () => {
                    try {
                        await tokenService.refreshAuthToken();
                    } catch (error) {
                        console.error(error);
                    }
                }, 1200000);
            })
        );
    },
};
